import axios from 'axios';
import { baseUrl, token } from '../../services/Apis';

export const ARCHIVOS_CONST = 'archivos';

export const allArchivosService = async (params) => {
  const res = await axios.get(`${baseUrl}/${ARCHIVOS_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveArchivosService = async (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  const res = await axios.post(`${baseUrl}/${ARCHIVOS_CONST}`, data, {
    headers: await token({
      isFormData: true,
    }),
  });
  return res;
};

export const oneArchivosService = async (id) => {
  const res = await axios.get(`${baseUrl}/${ARCHIVOS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteArchivosService = async (id) => {
  const res = await axios.delete(`${baseUrl}/${ARCHIVOS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const fileArchivosService = async (ruta) => {
  const res = await axios.get(`${baseUrl}/${ARCHIVOS_CONST}/${ruta}`, {
    responseType: 'blob', // Indica que se espera un Blob
    headers: token({}),
  });
  return res;
};
